import { Component } from '@theme/component';
import { onAnimationEnd } from '@theme/utilities';
import { ThemeEvents, CartUpdateEvent } from '@theme/events';

class CartIcon extends Component {
  requiredRefs = ['cartBubble', 'cartBubbleText', 'cartBubbleCount'];

  get currentCartCount() {
    return parseInt(this.refs.cartBubbleCount.textContent.replace(/[()]/g, '') ?? '0', 10);
  }

  set currentCartCount(value) {
    this.refs.cartBubbleCount.textContent = value < 100 ? `(${value})` : '';
  }

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.cartUpdate, this.onCartUpdate);
    window.addEventListener('pageshow', this.onPageShow);
    this.ensureCartBubbleIsCorrect();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.cartUpdate, this.onCartUpdate);
    window.removeEventListener('pageshow', this.onPageShow);
  }

  onPageShow = (event) => {
    if (event.persisted) {
      this.ensureCartBubbleIsCorrect();
    }
  };

  onCartUpdate = async (event) => {
    const itemCount = event.detail.data?.itemCount ?? 0;
    const comingFromProductForm = event.detail.data?.source === 'product-form-component';
    this.renderCartBubble(itemCount, comingFromProductForm);
  };

  renderCartBubble = async (itemCount, comingFromProductForm, animate = true) => {
    const effectiveCount = comingFromProductForm ? this.currentCartCount + itemCount : itemCount;

    this.refs.cartBubbleCount.classList.toggle('hidden', effectiveCount === 0);
    this.refs.cartBubble.classList.toggle('visually-hidden', effectiveCount === 0);

    this.currentCartCount = effectiveCount;

    this.classList.toggle('header-actions__cart-icon--has-cart', effectiveCount > 0);

    sessionStorage.setItem(
      'cart-count',
      JSON.stringify({
        value: String(this.currentCartCount),
        timestamp: Date.now(),
      })
    );

    if (!animate || effectiveCount === 0) return;

    await new Promise((resolve) => requestAnimationFrame(resolve));

    this.refs.cartBubble.classList.add('cart-bubble--animating');
    await onAnimationEnd(this.refs.cartBubbleText);
    this.refs.cartBubble.classList.remove('cart-bubble--animating');
  };

 ensureCartBubbleIsCorrect = () => {
  if (!this.refs.cartBubbleCount) return;

  const sessionStorageCount = sessionStorage.getItem('cart-count');
  if (sessionStorageCount === null) return;

  const visibleCount = this.refs.cartBubbleCount.textContent.replace(/[()]/g, '').trim();

  try {
    const { value, timestamp } = JSON.parse(sessionStorageCount);
    if (value === visibleCount) return;
    if (Date.now() - timestamp < 10000) {
      const count = parseInt(value, 10);
      // Never hide the bubble if Liquid already rendered items
      if (count > 0) {
        this.renderCartBubble(count, false, false);
      }
    }
  } catch (_) {
    // no-op
  }
};

}

if (!customElements.get('cart-icon')) {
  customElements.define('cart-icon', CartIcon);
}
